$(function () {

  const apiEndpoint = "https://tlbc-calculator.harttcommerce.com"
  const notAvailableSizes = [
    "26A",
    "26B",
    "26C",
    "26D",
    "26DD",
    "26DDD",
    "28AA",
    "28DD",
    "28DDD",
    "30AAA",
    "30AA",
    "30DD",
    "30DDD",
    "32AAA",
    "32DD",
    "34AAAA",
    "34AAA",
    "34D",
    "36AAAA",
    "36AAA",
    "36C",
    "38AAAA",
    "38AAA",
    "38AA",
    "38B",
    "40AAA",
    "40AA",
    "40A",
  ];
  const bust_to_band = {
    25: 28,
    25.5: 28,
    26: 28,

    26.5: 30,
    27: 30,
    27.5: 30,
    28: 30,

    28.5: 32,
    29: 32,
    29.5: 32,
    30: 32,

    30.5: 34,
    31: 34,
    31.5: 34,
    32: 34,

    32.5: 36,
    33: 36,
    33.5: 36,
    34: 36,

    34.5: 38,
    35: 38,
    35.5: 38,
    36: 38
  };

  const band_underbust_to_cup = {
    // These need to go up to underbust 36 if they are ever used.
    28: {
      25: 'A',
      25.5: 'A',
      26: 'A',

      26.5: 'B',
      27: 'B',
      27.5: 'B',
      28: 'B',

      28.5: 'C',
      29: 'C',
      29.5: 'C',
      30: 'C',

      30.5: 'D',
      31: 'D',
      31.5: 'D',
      32: 'D'
    },
    30: {
      26.5: 'A',
      27: 'A',
      27.5: 'A',
      28: 'A',

      28.5: 'B',
      29: 'B',
      29.5: 'B',
      30: 'B',

      30.5: 'C',
      31: 'C',
      31.5: 'C',
      32: 'C',

      32.5: 'D',
      33: 'D',
      33.5: 'D',
      34: 'D'
    },
    32: {
      28.5: 'A',
      29: 'A',
      29.5: 'A',
      30: 'A',

      30.5: 'B',
      31: 'B',
      31.5: 'B',
      32: 'B',

      32.5: 'C',
      33: 'C',
      33.5: 'C',
      34: 'C',

      34.5: 'D',
      35: 'D',
      35.5: 'D',
      36: 'D',

      26.5: 'AA',
      27: 'AA',
      27.5: 'AA',
      28: 'AA'
    },
    34: {
      30.5: 'A',
      31: 'A',
      31.5: 'A',
      32: 'A',

      32.5: 'B',
      33: 'B',
      33.5: 'B',
      34: 'B',

      34.5: 'C',
      35: 'C',
      35.5: 'C',
      36: 'C',

      28.5: 'AA',
      29: 'AA',
      29.5: 'AA',
      30: 'AA'
    },
    36: {
      32.5: 'A',
      33: 'A',
      33.5: 'A',
      34: 'A',

      34.5: 'B',
      35: 'B',
      35.5: 'B',
      36: 'B',

      30.5: 'AA',
      31: 'AA',
      31.5: 'AA',
      32: 'AA',
    },
    38: {
      34.5: 'A',
      35: 'A',
      35.5: 'A',
      36: 'A'
    }
  };


  function increaseCup(cup) {
    switch (cup) {
      case "A":
        return "B";
      case "AA":
        return "A";
      case "AAA":
        return "AA";
      case "B":
        return "C";
      case "C":
        return "D";
    }
    return "";
  }

  function decreseCup(cup) {
    switch (cup) {
      case "A":
        return "AA";
      case "AA":
        return "AAA";
      case "B":
        return "A";
      case "C":
        return "B";
      case "D":
        return "C";
    }
    return "";
  }

  function getCup() {
    const survey = this.survey;
    let bandFitVar = survey.data.band_fit;
    let cupFitVar = survey.data.cups_fit;
    let cupVar = survey.data.cup;
    let bust = survey.data.bust;

    if (bust) {
      const band = survey.getVariable('calc_band');
      if (!band) {
        return false;
      }
      return band_underbust_to_cup[band][parseFloat(bust)];
    }

    if (!bandFitVar || !cupFitVar || !cupVar) {
      return false;
    }

    const bandFit = bandFitVar.toLowerCase().trim();
    const cupFit = cupFitVar.toLowerCase().trim();

    let cup = cupVar;
    switch (true) {
      case cupFit === "too small" && bandFit === "too loose":
        // 2 times increase  
        cup = increaseCup(cup);
        return increaseCup(cup)
      case cupFit === "just right" && bandFit === "too loose":
        return increaseCup(cup);
      case cupFit === "too big" && bandFit === "too tight":
        cup = decreseCup(cup);
        return decreseCup(cup)
      case cupFit === "just right" && bandFit === "too tight":
        return decreseCup(cup);
      case cupFit === "too big" && bandFit === "just right":
        return decreseCup(cup);
      case cupFit === "too small" && bandFit === "just right":
        return increaseCup(cup);
      default:
        return cup;
    }
  }

  function getBand() {
    const survey = this.survey;
    let bandFitVar = survey.data.band_fit;
    let bandVar = survey.data.band;
    let underbust = survey.data.underbust;

    if (underbust) {
      return bust_to_band[parseFloat(underbust)];
    }

    if (!bandFitVar || !bandVar) {
      return false;
    }
    bandFitVar = bandFitVar.toLowerCase().trim();
    let band = parseInt(bandVar);
    switch (bandFitVar) {
      case "too loose":
        return band - 2;
      case "too tight":
        return band + 2;
      default:
        return band;
    }
  }

  function getSet() {
    const survey = this.survey;
    const fingers = survey.data.fingers;
    if (!fingers) return false;

    switch (fingers) {
      case "0-1 Finger":
        return "Close-set";
      case "2 Fingers":
        return "";
      case "3+ Fingers":
        return "Wide-set";
    }
    return ""
  }


  function getSize() {
    const survey = this.survey;
    const band = survey.getVariable('calc_band');
    const cup = survey.getVariable('calc_cup');
    if (!band || !cup) {
      return false;
    }
    if(notAvailableSizes.includes(`${band}${cup}`)) {
      return false;
    }
    
    return `${band}${cup}`;
  }

  function buildBust(survey, option) {
    const underbust = option.value;
    const band = bust_to_band[parseFloat(underbust)];
    
    const bustQ = survey.getQuestionByName("bust");
    let cups = {};
    for (var k in band_underbust_to_cup[band]) {
        if (band_underbust_to_cup[band].hasOwnProperty(k)) {
            cups[parseFloat(k)] = true;
        }
    }
    cups = Object.keys(cups).sort().reduce(
      (obj, key) => { 
        obj[key] = cups[key]; 
        return obj;
      }, 
      {}
    );
    bustQ.choices.forEach((v)=>{
      if(cups[v.value]) {
          v.setVisible(true);  
      }else {
        v.setVisible(false);
      }
    });
  }


  fetch(`${apiEndpoint}/api/calculator`)
    .then((response) => response.json())
    .then((data) => {
      Survey.FunctionFactory.Instance.register("getCup", getCup);
      Survey.FunctionFactory.Instance.register("getBand", getBand);
      Survey.FunctionFactory.Instance.register("getSet", getSet);
      Survey.FunctionFactory.Instance.register("getSize", getSize);

      const survey = new Survey.Model(data.calculator_data);
      survey
      .onValueChanged
      .add(function (sender, options) {
          if(options.name == "underbust") {
              buildBust(sender, options);
          }
      });
      survey.onComplete.add(onComplete);

      $("#calcContainer").Survey({ model: survey })

    });

  function onComplete(event) {
    console.log("calculator completed",event.data);
    const customer = $("#customer");
    let customerData = {
      email: customer.data("customermail"),
      id: customer.data("customerid"),
    };

    const data = event.data;
    const size = data.calc_size;
    
    if(!size) {
      console.log("no size");
      $("#start-over").show();
      return;
    }

    if(data.calc_set == '') {
      $(".img-set").remove();
    }

    $('#loader').show();

    callAPI(size, {size: size, style: data.looking, padding: data.padding, set: data.calc_set, customer_id: customerData.id, customer: customerData.email}, function(result) {
      console.log("api result", result);
      $('#loader').hide();
      $("#start-over").show();
      //$("._be_launch_popup").click();
      
      const resultContainer = $('#results');

      if(!result.bras) {
        resultContainer.append(`<div>
        <h2>It looks like we currently don’t have a style that matches your exact request. </h2>
        <span class="product-item__title">However, we do have dozens of other styles in our collection that you still might like. We invite you to browse some more at <a href="https://www.thelittlebracompany.com/collections/bras">https://www.thelittlebracompany.com/collections/bras</a>, and if you still can’t find what you are looking for, please feel free to contact one of our fit specialists. We look forward to helping you! Email a fit specialist at <a href="mailto:info@thelittlebracompany.com">info@thelittlebracompany.com</a> or give us a call at 310.254.8542</span>
        </div>`);
        resultContainer.show();
        return;
      }

              resultContainer.append(`<div>
        <a href="/collections/essentials" target="_blank" tabindex="0">
        <img class="recommended-img" src="https://cdn.shopify.com/s/files/1/0671/0817/files/essentials_petitebras.jpg?v=1719516919" alt="Essentials">
        <span class="product-item__title">Essentials</span>
        
        <span class="product-item__title"></span>
        </a>
        </div>`);

      for(var i = 0; i < result.bras.length; i++) {
        const bra = result.bras[i];
        resultContainer.append(`<div>
        <a href="/products/${bra.handle}?variant=${bra.variant_id}" target="_blank" tabindex="0">
        <img class="recommended-img" src="${bra.image}" alt="${bra.title}">
        <span class="product-item__title">${bra.title}</span>
        
        <span class="product-item__title">${bra.size}</span>
        </a>
        </div>`);
      }
      resultContainer.show();

      resultContainer.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 3,
        nextArrow: '<i class="right-arrow"></i>',
        prevArrow: '<i class="left-arrow"></i>',
        cssEase: 'linear',
        responsive: [{
            breakpoint: 1024,
              settings: {
                  slidesToShow: 4,
              }
           }, {
              
            breakpoint: 600,
              settings: {
                  slidesToShow: 2,
              }
            }, {

            breakpoint: 300,
                settings: {
                  slidesToShow: 2,
                }
          }]
      });

      $("#subinformation").show();

    })
  }


  function callAPI(size, data, callback) {
    fetch(`${apiEndpoint}/api/calculator/results?size=${size}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((result) => {
        callback(result)
      })
  }
  
});